import React, {useContext} from "react";
import "./Skills.scss";
import SoftwareSkill from "../../components/softwareSkills/SoftwareSkill";
import {skillsSection} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function Skills() {
  const {isDark} = useContext(StyleContext);
  if (!skillsSection.display) {
    return null;
  }

  const sections = Array.isArray(skillsSection.sections)
    ? skillsSection.sections
    : [
        {
          title: skillsSection.title,
          subTitle: skillsSection.subTitle,
          skills: skillsSection.skills,
          softwareSkills: skillsSection.softwareSkills
        }
      ];

  const combinedSoftwareSkills = sections
    .flatMap(section =>
      Array.isArray(section.softwareSkills) ? section.softwareSkills : []
    )
    .filter(Boolean)
    .reduce(
      (unique, item) => {
        const key = `${item.skillName || ""}::${
          item.fontAwesomeClassname || ""
        }`;
        if (unique.seen.has(key)) return unique;
        unique.seen.add(key);
        unique.items.push(item);
        return unique;
      },
      {
        items: [],
        seen: new Set()
      }
    ).items;

  return (
    <div className={isDark ? "dark-mode main" : "main"} id="skills">
      <div className="skills-main-div">
        <Fade left duration={1000}>
          <div className="skills-image-div">
            <SoftwareSkill softwareSkills={combinedSoftwareSkills} />
          </div>
        </Fade>
        <Fade right duration={1000}>
          <div className="skills-text-div">
            {sections.map((section, sectionIndex) => {
              return (
                <div
                  className={
                    sectionIndex === 0
                      ? "skills-section-block"
                      : "skills-section-block skills-section-block-spaced"
                  }
                  key={sectionIndex}
                >
                  {sectionIndex === 0 ? (
                    <h1
                      className={
                        isDark ? "dark-mode skills-heading" : "skills-heading"
                      }
                    >
                      {section.title}{" "}
                    </h1>
                  ) : (
                    <h2
                      className={
                        isDark ? "dark-mode skills-heading" : "skills-heading"
                      }
                    >
                      {section.title}{" "}
                    </h2>
                  )}

                  <p
                    className={
                      isDark
                        ? "dark-mode subTitle skills-text-subtitle"
                        : "subTitle skills-text-subtitle"
                    }
                  >
                    {section.subTitle}
                  </p>

                  <div>
                    {(section.skills || []).map((skills, i) => {
                      return (
                        <p
                          key={i}
                          className={
                            isDark
                              ? "dark-mode subTitle skills-text"
                              : "subTitle skills-text"
                          }
                        >
                          {skills}
                        </p>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </Fade>
      </div>
    </div>
  );
}
